import { render, staticRenderFns } from "./insure-info.vue?vue&type=template&id=7db6a1b3&"
import script from "./insure-info.vue?vue&type=script&lang=js&"
export * from "./insure-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports